import React from "react";
import { useMsal } from "@azure/msal-react";

export const SignOutButton = () => {
    const { instance } = useMsal();

    const handleLogout = (logoutType: "popup" | "redirect") => {
        if (logoutType === "popup") {
            instance.logoutPopup({
                postLogoutRedirectUri: "/",
                mainWindowRedirectUri: "/"
            });
        } else if (logoutType === "redirect") {
            instance.logoutRedirect({
                postLogoutRedirectUri: "/",
            });
        }
    };

    return (
        <button 
            onClick={() => handleLogout("redirect")}
            className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md flex items-center space-x-2"
        >
            <svg 
                xmlns="http://www.w3.org/2000/svg" 
                className="h-4 w-4 text-blue-500" 
                viewBox="0 0 20 20" 
                fill="none"
            >
                <path 
                    fillRule="evenodd" 
                    clipRule="evenodd" 
                    d="M1.00024 4.37615V1H10.0003V4.37615H4.37527V15.6263H10.0003V19.0002H4.37527H1.00024V15.6263V4.37615ZM6.61036 7.7503H12.25V4.36739L19.0001 10.0003L12.25 15.6332V12.2503H6.61036V7.7503Z" 
                    fill="currentColor" 
                />
            </svg>
            <span>Log out</span>
        </button>
    );
};
